import { render, staticRenderFns } from "./SeeMoreButton.vue?vue&type=template&id=54798050&scoped=true&"
import script from "./SeeMoreButton.vue?vue&type=script&lang=js&"
export * from "./SeeMoreButton.vue?vue&type=script&lang=js&"
import style0 from "./SeeMoreButton.vue?vue&type=style&index=0&id=54798050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54798050",
  null
  
)

export default component.exports